module.exports = __webpack_public_path__ + "img/empty3.f05964d5.png";